const UnlockBy = Object.freeze({
    NONE: null,
    FREE_POWER: "FREE_POWER",
    PAY: "PAY",
    APP: "APP",
    NFC: "NFC",
});

module.exports = UnlockBy;